
import { React, useState } from "react";
import "./DLF.css";

function DLF() {
  //const [readMore, setReadMore] = useState(null);
  // const linkName = readMore == null ? 'Read More' : 'Read Less';
  const [isFlipped, setIsFlipped] = useState(null);

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    console.log(open, "openKiValue");
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <div className="dlf-container">
        <div className="dlf-wrap">
          {/* <h2>Delivery Learning Framework (DLF 3.0)</h2> */}
          <p className="intro-text">
            DLF3.0 is a set of pre-defined trainings for all career levels from
            Associate to Senior Managers. This will help enhance the required
            delivery skills while reinforcing existing knowledge.
          </p>
          <div className="dlf-row-flip">
            <div className="dlfCard-wrapper">
              <div
                className={isFlipped == "1" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "1"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <Link to={'/securitySchools'} className="calendar-link"> */}
                    <img
                      src="./images/Delivery/DFA.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-cont">
                      <h3>Delivery Foundation Academy</h3>
                      <p>
                      Delivery Foundation Academy (DFA) features learnings designed to impart the basic&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("1")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        href="https://atci.lkm.delivery.accenture.com/DLF/DFA"
                        target="_blank"
                      >
                        Delivery Foundation Academy
                      </a>
                    </div>
                    {/* </Link> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "1" ? setIsFlipped(null) : setIsFlipped("1")
                    }
                  >
                    <h3 className="backHeading">
                    Delivery Foundation Academy
                    </h3>
                    <p>Delivery Foundation Academy (DFA) features learnings designed to impart the basic
Read Lessdelivery skills required at a specific career level. The learnings focuses on process, methodologies, programming fundamentals, tools and techniques required for a seamless delivery.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="dlfCard-wrapper">
              <div
                className={isFlipped == "2" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "2"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <Link to={'/securitySchools'} className="calendar-link"> */}
                    <img
                      src="./images/Delivery/SFA.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-cont">
                      <h3>Security Foundation Academy</h3>
                      <p>
                      Security Foundation Academy covers basic security aspects that one should be aware of&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("2")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        href="https://atci.lkm-securitylearnings.accenture.com/SecurityFoundationAcademy/"
                        target="_blank"
                      >
                        Security Foundation Academy
                      </a>
                    </div>
                    {/* </Link> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "2" ? setIsFlipped(null) : setIsFlipped("2")
                    }
                  >
                    <h3 className="backHeading">
                    Security Foundation Academy
                    </h3>
                    <p>
                    Security Foundation Academy covers basic security aspects that one should be aware of
Read Lessand practice in their daily work. It includes the best practices to follow when accessing the production environment, the processes, controls and standards that must be followed to protect client data.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="dlfCard-wrapper">
              <div
                className={isFlipped == "3" ? "flip-card" : "flip-card-unhover"}
              >
                <div
                  className={
                    isFlipped == "3"
                      ? "flip-card-inner"
                      : "flip-card-inner-unhover"
                  }
                >
                  <div className="SSA-box-front">
                    {/* <Link to={'/securitySchools'} className="calendar-link"> */}
                    <img
                      src="./images/Delivery/DAA.png"
                      alt="SSA-img"
                      className="SSA-img"
                    />
                    <div className="SSA-box-cont">
                      <h3>Delivery Adept Academy for Security</h3>
                      <p>
                      Delivery Adept Academy (DAA) for Security is designed for a career level with necessary&nbsp;
                        <a
                          className="learn-more"
                          onClick={() =>
                            isFlipped == null
                              ? setIsFlipped("3")
                              : setIsFlipped(null)
                          }
                        >
                          Learn more
                        </a>
                      </p>
                      <a
                        href="https://atci.lkm-securitylearnings.accenture.com/DeliveryAdeptAcademy/"
                        target="_blank"
                      >
                        Delivery Adept Academy for Security
                      </a>
                    </div>
                    {/* </Link> */}
                  </div>
                  <div
                    className="SSA-box-back"
                    onMouseLeave={() =>
                      isFlipped == "3" ? setIsFlipped(null) : setIsFlipped("3")
                    }
                  >
                    <h3 className="backHeading">
                      Delivery Adept Academy for Security
                    </h3>
                    <p>
                    Delivery Adept Academy (DAA) for Security is designed for a career level with necessary
Read Lesssecurity specialization to attain focused security delivery skills across security workforce.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DLF;

